(ns frontend.view.grid.exit-opportunities-grid.view
  (:require
   [clojure.string :as string]
   [common.entity :as entity]
   [common.fields.table-column-widths :as widths]
   [common.localization :as loc]
   [common.schema.registry :as registry]
   [common.status :as statuses]
   [common.teams :as teams]
   [common.util :as cu]
   [frontend.actions.exit-opportunity :as exit-opportunity-actions]
   [frontend.db :as app-db]
   [frontend.local-storage :as ls]
   [frontend.logging :as logging]
   [frontend.page-components.default-page-layout :as default-page-layout]
   [frontend.page-components.zap-toolbar :as zap-toolbar]
   [frontend.react.virtualized.scrollable-grid.common :as grid]
   [frontend.react.virtualized.scrollable-grid.components :as grid-components]
   [frontend.react.virtualized.scrollable-grid.kanban :as kanban]
   [frontend.react.virtualized.scrollable-grid.view :as scrollable-grid]
   [frontend.react.virtualized.utils :as vu]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.tenant-customizations :as tenant-customizations]
   [frontend.ux-overhaul.listing.exit-opportunity.view :as listing-exit-opportunity]
   [frontend.ux-overhaul.listing.pipeline-entity :as pipeline-entity]
   [frontend.utils :as fu]
   [frontend.view.components.grid-filters.view :as grid-filters]
   [frontend.page-components.navbar-components.create-dropdown :as create-dropdown]
   [frontend.view.entity :as f-entity]
   [frontend.view.grid.common.components :as components]
   [frontend.view.grid.common.utils :as grid-utils]
   [frontend.view.grid.exit-opportunities-grid.db :as db]
   [frontend.view.grid.exit-opportunities-grid.events :as events]
   [frontend.view.modals.bulk-edit-entity.view :as bulk-edit-modal]
   [frontend.view.modals.curtains.exit-opportunity.lost-curtain :as lost-curtain]
   [frontend.view.modals.curtains.exit-opportunity.on-hold-curtain :as on-hold-curtain]
   [frontend.view.modals.curtains.pipeline-settings-curtain.view :as pipeline-settings-curtain]
   [frontend.view.modals.curtains.tenant-custom-filter-curtain.view :as
    tenant-custom-filter-curtain]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.folder-management-check-lists-modal.view :as folder-management-check-lists-modal]
   [frontend.view.modals.folder-management-modal.view :as folder-management-modal]
   [frontend.view.named-view.events :as named-view-events]
   [frontend.view.not-found :as not-found]
   [potpuri.core :as potpuri]
   [reagent.core :as r]
   [ui.components.button.view :as button]
   [ui.editors.entity-creator.view :as creator-editor]))

(defonce select-width 30)

(defn column
  [args]
  (let [{:keys [label attribute field-schema filter-data sorting-disabled? width hover-atom
                recompute-grid-sizes! flex-grow]}
        args
        default-width (-> (widths/get-column-width attribute)
                          :default-width
                          (or widths/default-width))]
    {:label               label
     :data-key            attribute
     :field-schema        field-schema
     :filter-data         filter-data
     :update-filter!      (fn [k filter-data]
                            (grid/set-filter (events/setup-args) k filter-data))
     :sort-disabled?      (boolean sorting-disabled?)
     :min-width           (-> (widths/get-column-width attribute)
                              :min-width
                              (or widths/min-width))
     :max-width           (-> (widths/get-column-width attribute)
                              :max-width
                              (or widths/max-width))
     :default-width       default-width
     :width               (or width default-width)
     :set-width           width
     :begin-width-update! (partial grid/begin-width-update! hover-atom attribute)
     :update-width!
     (partial grid/update-width! (events/setup-args) recompute-grid-sizes! hover-atom attribute)
     :end-width-update!   (partial grid/end-width-update! hover-atom attribute)
     :get-styling         (partial grid/get-styling hover-atom attribute)
     :flex-grow           flex-grow}))

(defn toolbar-actions
  [{:keys [view-mode]}]
  (let [all-teams (->> @session/all-teams
                       (remove :common/disabled?))
        account-teams (teams/resolve-account-teams @session/account all-teams)]
    [{:toolbar-button?  true
      :dropdown-action? true
      :hidden?          (fn []
                          (= view-mode :board-mode))
      :ord              2
      :primary-button?  false
      :add-ellipsis?    true
      :on-select        (fn [_e]
                          (grid/open-select-columns-curtain (events/setup-args)))
      :label            (if (= view-mode :board-mode)
                          (loc/tr :select-columns)
                          (loc/tr :action/select-columns))}
     (grid-utils/export-button {:account-teams  account-teams
                                :button-ord     3
                                :grid-state     db/exit-opportunities
                                :column-keys-fn events/resolve-column-keys})

     (when (and (not (session/is-read-only-user?))
                (not (session/exit-oppo-creation-flow?)))
       {:toolbar-button?  true
        :dropdown-action? true
        :ord              1
        :icon             :fa-plus
        :primary-button?  true
        :on-select        (fn [_e]
                            (f-entity/open-creator! :entity.type/exit-opportunity {}))
        :label            (loc/tr :exit-opportunity-add-button)})

     (when (and (session/exit-oppo-creation-flow?)
                (not (session/is-read-only-user?)))
       {:toolbar-button?  true
        :dropdown-action? true
        :ord              1
        :icon             :fa-plus
        :primary-button?  true
        :sub-menu-side    :left
        :items
        (let [pipeline-id @session/selected-exit-oppo-pipeline
              pipeline @(r/track session/get-entity pipeline-id)
              items (create-dropdown/pipeline-stage-items
                     {:entity-type :entity.type/exit-opportunity
                      :pipeline pipeline})]
          items)
        :label (loc/tr :exit-opportunity-add-button)})

     (when (session/is-admin?)
       {:toolbar-button?  false
        :dropdown-action? true
        :ord              10
        :add-ellipsis?    true
        :label            (loc/tr :pipeline-stages)
        :primary-button?  true
        :on-select        (fn [_e]
                            (modals/open-modal!
                             pipeline-settings-curtain/modal-key
                             {:pipeline-id          @session/selected-exit-oppo-pipeline
                              :stage-entity-type    :entity.type/exit-opportunity-stage
                              :stage-name-attribute :exit-opportunity-stage/name
                              :pipeline-attribute   :exit-opportunity-stage/pipeline}))})
     (when (session/is-admin?)
       {:toolbar-button?  false
        :dropdown-action? true
        :ord              12
        :add-ellipsis?    true
        :label            (loc/tr :pipeline-folders)
        :primary-button?  true
        :on-select        (fn [_e]
                            (modals/open-modal!
                             folder-management-modal/modal-key
                             {:entity @session/selected-exit-oppo-pipeline-entity}))})
     (when (and (session/is-admin?)
                (not (session/is-read-only-user?)))
       {:toolbar-button?  false
        :dropdown-action? true
        :ord              13
        :add-ellipsis?    true
        :label            (loc/tr :pipeline-checklists)
        :primary-button?  true
        :on-select        (fn [_e]
                            (modals/open-modal!
                             folder-management-check-lists-modal/modal-key
                             {:entity           @session/selected-exit-oppo-pipeline-entity
                              :check-lists-atom session/check-lists}))})
     {:divider? true
      :dropdown-action? true
      :ord 14}

     (grid-utils/creator-config-item
      {:ord 15
       :entity-type :entity.type/exit-opportunity
       :pipeline @(r/track session/get-entity @session/selected-exit-oppo-pipeline)})

     (when (= view-mode :board-mode)
       {:toolbar-button?  false
        :dropdown-action? true
        :ord              16
        :add-ellipsis?    true
        :label            (loc/tr :card-settings)
        :on-select        (fn [_e]
                            (events/open-card-settings!))})

     {:divider? true
      :dropdown-action? true
      :ord 17}

     (grid-utils/preferred-landing-page-toggle {:view-id :exit-opportunities-grid
                                                :pipeline-id @session/selected-exit-oppo-pipeline
                                                :pipeline-key :exit-opportunity-pipeline})]))

(defn toolbar-buttons-renderer
  []
  (let [setup-args (events/setup-args)
        modal-atom (:modal-state setup-args)
        open-bulk-edit! #(swap! modal-atom assoc :bulk-edit-modal true)
        selected (grid/get-selected-items setup-args)]
    [:div
     {:class "flex gap-2"}
     (if (session/is-read-only-user?)
       [:span (loc/tr :no-grid-actions-for-read-only-user)]
       [:<>
        [components/toolbar-delete-button
         {:max-delete-count   10000
          :selected-items     (grid/get-selected-items setup-args)
          :on-delete-clicked! events/delete-selected-clicked}]
        [components/toolbar-bulk-edit-button
         {:max-bulk-edit-count   10000
          :selected-items        selected
          :on-bulk-edit-clicked! open-bulk-edit!}]])]))

(defn open-lost-curtain!
  [{:keys [entity reset-focus!]}]
  (when (session/is-mobile?)
    (.scrollTo js/window 0 0))
  (modals/open-modal!
   lost-curtain/modal-key
   {:exit-opportunity-id (:db/id entity)
    :reset-focus!        reset-focus!}))

(defn open-on-hold-curtain!
  [{:keys [entity reset-focus!]}]
  (when (session/is-mobile?)
    (.scrollTo js/window 0 0))
  (modals/open-modal!
   on-hold-curtain/modal-key
   {:exit-opportunity-id (:db/id entity)
    :reset-focus!        reset-focus!}))

(defn status-options
  [entity]
  (->> statuses/exit-opportunity-status-options
       (remove
        (fn [status]
          (cond
            (= (:exit-opportunity/status entity) :exit-opportunity.status/won)
            (some #{(:key status)}
                  [:exit-opportunity.status/won
                   :exit-opportunity.status/on-hold
                   :exit-opportunity.status/lost])

            (= (:exit-opportunity/status entity) :exit-opportunity.status/lost)
            (some #{(:key status)}
                  [:exit-opportunity.status/won :exit-opportunity.status/lost])

            (= (:exit-opportunity/status entity) :exit-opportunity.status/on-hold)
            (some #{(:key status)}
                  [:exit-opportunity.status/won :exit-opportunity.status/on-hold])

            (= (:exit-opportunity/status entity) :exit-opportunity.status/active)
            (= (:key status) :exit-opportunity.status/active))))))

(defn change-status!
  [{:keys [entity new-value reset-focus!]}]
  (let [lost? (and (= new-value :exit-opportunity.status/lost)
                   (some #{(:exit-opportunity/status entity)}
                         [:exit-opportunity.status/active :exit-opportunity.status/on-hold]))
        on-hold? (and (= new-value :exit-opportunity.status/on-hold)
                      (some #{(:exit-opportunity/status entity)}
                            [:exit-opportunity.status/active :exit-opportunity.status/lost]))
        won? (and (= new-value :exit-opportunity.status/won)
                  (some #{(:exit-opportunity/status entity)} [:exit-opportunity.status/active]))
        resurrect? (and (= new-value :exit-opportunity.status/active)
                        (some #{(:exit-opportunity/status entity)}
                              [:exit-opportunity.status/won
                               :exit-opportunity.status/on-hold
                               :exit-opportunity.status/lost]))]
    (cond
      lost?
      (open-lost-curtain! {:entity       entity
                           :reset-focus! reset-focus!})

      on-hold?
      (open-on-hold-curtain! {:entity       entity
                              :reset-focus! reset-focus!})

      won?
      (events/won! {:entity       entity
                    :reset-focus! reset-focus!})

      resurrect?
      (do
        (exit-opportunity-actions/*->resurrect!
         {:exit-opportunity-id (:db/id entity)}
         identity
         (partial logging/error "Failed to set exit opportunity as active "))
        (when reset-focus!
          (reset-focus!)))

      :else nil)))

(defn create-props-atom
  [selected sorted-grid-entities filters grid-store
   recompute-grid-sizes! hover-atom modal-atom]
  (let [tenant-schema @session/tenant-schema
        columns
        (vec (keep (fn [k]
                     (let [field-schema (registry/get-field-schema tenant-schema k)
                           label (events/get-label k)]
                       (column {:label                 label
                                :attribute             k
                                :field-schema          field-schema
                                :filter-data           (get filters k)
                                :sorting-disabled?     false
                                :width                 (grid/get-saved-width (events/setup-args) k)
                                :hover-atom            hover-atom
                                :recompute-grid-sizes! recompute-grid-sizes!
                                :flex-grow             1})))
                   (events/resolve-column-keys)))
        editable-grid? (and (session/has-feature-access? :feature/editable-grid)
                            @session/editable-grid?)]
    (r/atom
     {:grid-store              grid-store
      :setup-args              (events/setup-args)
      :recalculate!            #(grid/recalculate (events/setup-args))
      :grid-entities           sorted-grid-entities
      :grid-entity-ids         (->> sorted-grid-entities
                                    (mapv :db/id)
                                    (into #{}))
      :selected                selected
      :link-to-entity-field    :exit-opportunity/name
      :header-height           50
      :editable-grid?          editable-grid?
      :select-width            select-width
      :min-columns-width       30
      :height                  (- (or (:height @app-db/window) 400)
                                  (or (:fixed-navbars-height @app-db/window) 0)
                                  75)                                                               ;; TODO: lazy - fixed 120px for button row in this view
      :avail-height            (- (or (:height @app-db/window) 400)
                                  (or (:fixed-navbars-height @app-db/window) 0)
                                  75)                                                               ;; TODO: lazy - fixed 120px for button row in this view
      :useDynamicRowHeight     false                                                                ;; TODO: kebab-case
      :row-height              40                                                                   ;(fn [index] 40)
      :row-count               (if (sequential? sorted-grid-entities)
                                 (count sorted-grid-entities)
                                 0)
      :scrollToIndex           0
      :overscan-count          1
      :columns                 columns
      :no-rows-renderer        (r/partial grid/default-no-rows-render
                                          @db/exit-opportunities
                                          :entity.type/exit-opportunity)
      :read-only-fields        [:exit-opportunity/on-hold-until
                                :exit-opportunity/on-hold-comment
                                :exit-opportunity/on-hold
                                :exit-opportunity/put-on-hold
                                :exit-opportunity/put-on-hold-on
                                :exit-opportunity/lost-comment
                                :exit-opportunity/lost-on
                                :exit-opportunity/won-on
                                :exit-opportunity/pipeline]
      :pipeline-key            :exit-opportunity/pipeline
      :owner-key               :exit-opportunity/owner
      :status-key              :exit-opportunity/status
      :status-options          status-options
      :on-row-click!           (fn [row]
                                 (let [data (when (< row (count sorted-grid-entities))
                                              (nth sorted-grid-entities row))]
                                   (routing/open-entity (:db/id data))))
      :on-cell-click           (fn [row col]
                                 (grid/handle-cell-click!
                                  {:columns              columns
                                   :col                  col
                                   :row                  row
                                   :sorted-grid-entities sorted-grid-entities
                                   :state                hover-atom}))
      :change-status!          change-status!
      :is-sorted-by?           (partial grid/is-sorted-by db/view-settings)
      :is-secondary-sorted-by? (partial grid/is-secondary-sorted-by db/view-settings)
      :sort-by!                (fn [k dir]
                                 (grid/set-sort-by (events/setup-args) k dir))
      :reorder-columns!        (fn [dragged-column after-column]
                                 (grid/reorder-columns! (events/setup-args)
                                                        dragged-column
                                                        after-column))
      :can-filter?             (fn [_k]
                                 true)
      :resizing-column         (some-> @hover-atom
                                       (get :resize-start-width)
                                       (first)
                                       (key))
      :recompute-grid-sizes!   recompute-grid-sizes!
      :all-selection!          (fn []
                                 (let [selected (:selected @db/exit-opportunities)]
                                   (if (or (= :all selected) (not-empty selected))
                                     (grid/clear-selection! (events/setup-args))
                                     (swap! db/exit-opportunities assoc :selected :all))))
      :select-action-renderer  toolbar-buttons-renderer
      :on-row-select!          (fn [index checked]
                                 (let [data (when (< index (count sorted-grid-entities))
                                              (nth sorted-grid-entities index))
                                       exit-opportunity-id (:db/id data)]
                                   (if (= selected :all)
                                     (grid/select-all-but (events/setup-args) exit-opportunity-id)
                                     (if (boolean checked)
                                       (swap! db/exit-opportunities assoc-in
                                              [:selected exit-opportunity-id]
                                              true)
                                       (swap! db/exit-opportunities potpuri/dissoc-in
                                              [:selected exit-opportunity-id])))))
      :deselect-entity!        (fn [entity-id]
                                 (if (= selected :all)
                                   (grid/select-all-but (events/setup-args) entity-id)
                                   (swap! db/exit-opportunities potpuri/dissoc-in [:selected entity-id])))
      :row-data-getter
      (fn [index]
        (let [data (when (< index (count sorted-grid-entities))
                     (nth sorted-grid-entities index))]
          (merge {:selected            (or (= selected :all)
                                           (get (:selected @db/exit-opportunities) (:db/id data)))
                  :tooltip-text-getter (fn [data-key]
                                         (when (and (= data-key :exit-opportunity/buyer)
                                                    (:exit-opportunity/buyer data))
                                           (loc/tr :click-to-open)))}
                 data)))

      :new-action-view         {:in-use?         true
                                :open-bulk-edit! #(swap! modal-atom assoc :bulk-edit-modal true)
                                :bulk-delete!    events/delete-selected-clicked
                                :modal-atom      modal-atom}})))

(defn render
  [grid-store _view-mode]
  (let [hover-atom (r/atom {:hover {:col nil :row nil}})

        entity-type :entity.type/exit-opportunity

        ;;for saving grid references:
        recompute-grid-sizes! (fn []
                                (js/setTimeout
                                 (partial vu/recompute-grid-sizes-with-state! grid-store)
                                 0))]
    (fn [view-mode]
      (let [tenant-schema @session/tenant-schema
            selected (:selected @db/exit-opportunities)
            filters @db/exit-opportunity-filters
            all-columns (events/resolve-column-key-universe)
            sorted-grid-entities (:sorted-grid-entities @db/exit-opportunities)
            setup-args @(r/track events/setup-args)
            modal-atom (:modal-state setup-args)
            grid-atom (create-props-atom selected
                                         sorted-grid-entities
                                         filters
                                         grid-store
                                         recompute-grid-sizes!
                                         hover-atom
                                         modal-atom)
            card-settings? (:card-settings? @db/kanban)
            show-quick-filters? (:show-quick-filters? @db/exit-opportunities)
            show-bulk-edit-modal? (:bulk-edit-modal @modal-atom)

            filters-props {:pipeline-id                  @session/selected-exit-oppo-pipeline
                           :minimized?                   (not show-quick-filters?)
                           :tenant-custom-filter-options (when (tenant-customizations/capman?)
                                                           [{:value :custom-filter-exit-investor-contact-country
                                                             :label (loc/tr :custom-filter-exit-investor-contact-country)}])
                           :hide-maximize?               true
                           :universal-search?            true
                           :search-placeholder           (loc/tr :search-for-an-exit-opportunity)
                           :setup-args                   (events/setup-args)
                           :set-universal-search!        (r/partial grid/set-universal-search! setup-args)
                           :set-name-search!             (r/partial grid/set-name-search! setup-args)
                           :hide-named-views?            true
                           :named-views                  (events/named-views)
                           :current-view                 @db/view-settings
                           :columns                      (events/resolve-column-keys)
                           :all-columns                  all-columns
                           :get-column-label             events/get-label
                           :set-filter!                  (fn [k filter-data]
                                                           (grid/set-filter (events/setup-args) k filter-data))
                           :edit-custom-filter!
                           (fn [k filter-data]
                             (case k
                               :custom-filter-exit-investor-contact-country
                               (modals/open-modal!
                                tenant-custom-filter-curtain/modal-key
                                (merge
                                 filter-data
                                 {:on-ok!
                                  (fn [args]
                                    (grid/set-filter
                                     (events/setup-args)
                                     :custom-filter-exit-investor-contact-country
                                     (merge
                                      {:label (if (:selected-cities args)
                                                (loc/tr
                                                  :custom-filter-exit-investor-contact-country-and-city-label
                                                  [(string/join ", " (:selected-countries args))
                                                   (string/join ", " (:selected-cities args))])
                                                (loc/tr
                                                  :custom-filter-exit-investor-contact-country-label
                                                  [(string/join ", " (:selected-countries args))]))}
                                      args)))}))
                               nil))
                           :edit-filter!
                           (fn [k filter-data]
                             (grid/open-filter-curtain
                              {:field-key      k
                               :field-schema   (registry/get-field-schema tenant-schema k)
                               :field-label-fn events/get-label
                               :options        (->> all-columns
                                                    (map (juxt identity
                                                               (partial registry/get-field-schema
                                                                        tenant-schema))))
                               :current-filter filter-data
                               :update-fn!     (fn [k filter-data]
                                                 (grid/set-filter (events/setup-args) k filter-data))}
                              nil))
                           :hide-qf-attributes           [:exit-opportunity/buyer
                                                          :exit-opportunity/pipeline
                                                          [:exit-opportunity/buyer :investor/name]
                                                          [:exit-opportunity/buyer :investor/owner]
                                                          :exit-opportunity/target-holding
                                                          [:exit-opportunity/target-holding
                                                           :holding/name]
                                                          [:exit-opportunity/target-holding
                                                           :holding/owner]]
                           :load-view!                   (fn [named-view]
                                                           (events/load-view! named-view)
                                                           (grid/clear-selection! {:state db/exit-opportunities}))
                           :save-view!                   events/save-current-view!
                           :delete-view!                 named-view-events/delete-view!
                           :toggle-minimize!             (fn []
                                                           (events/toggle-quick-filters!)
                                                           (.setTimeout js/window recompute-grid-sizes! 1000))}]
        (if card-settings?
          [kanban/card-settings-view (events/setup-args)]
          [:<>
           [grid-filters/view
            filters-props]
           [creator-editor/modal-view]
           [:div.grid-view
            {:class "ps-4"}
            [:div
             {:class-name (fu/cs "grid-view-content"
                                 (when-not show-quick-filters? "named-views-minimized")
                                 (when (= view-mode :board-mode) "board-view"))}

             (when show-bulk-edit-modal?
               [bulk-edit-modal/view
                {:setup-args   setup-args
                 :entity-type  entity-type
                 :close-modal! #(swap! modal-atom dissoc :bulk-edit-modal)}])

             (if (= view-mode :board-mode)
               [kanban/view
                {:setup-args   (events/setup-args)
                 :card-classes (fn [exit-opportunity]
                                 (case (:exit-opportunity/status exit-opportunity)
                                   :exit-opportunity.status/active "status-active"
                                   :exit-opportunity.status/on-hold "border-warning-regular"
                                   :exit-opportunity.status/lost "border-danger-light-border"
                                   :exit-opportunity.status/won "border-base-light-border-accent"
                                   "status-unknown"))
                 :card-actions (concat
                                [(kanban/open-entity-action
                                  {:entity-type :entity.type/exit-opportunity})]
                                (when-not (session/is-read-only-user?)
                                  [{:id         "pass-exit-opportunity"
                                    :label      (loc/tr :pipeline-card-lost-action)
                                    :icon       "fal fa-ban"
                                    :hidden?    (fn [{:keys [entity]}]
                                                  (not (some #{(:exit-opportunity/status entity)}
                                                             [:exit-opportunity.status/active
                                                              :exit-opportunity.status/on-hold])))
                                    :on-select! open-lost-curtain!}
                                   {:id         "put-exit-opportunity-on-hold"
                                    :label      (loc/tr :pipeline-card-put-on-hold-action)
                                    :icon       "fal fa-pause-circle"
                                    :hidden?    (fn [{:keys [entity]}]
                                                  (not (some #{(:exit-opportunity/status entity)}
                                                             [:exit-opportunity.status/active
                                                              :exit-opportunity.status/lost])))
                                    :on-select! open-on-hold-curtain!}
                                   {:id         "won-action"
                                    :label      (loc/tr :won)
                                    :icon       "fal fa-check"
                                    :hidden?    (fn [{:keys [entity]}]
                                                  (not (some #{(:exit-opportunity/status entity)}
                                                             [:exit-opportunity.status/active])))
                                    :on-select! (fn [{:keys [entity]}]
                                                  (events/won! {:entity entity}))}
                                   {:id      "reactivate-exit-opportunity"
                                    :label   (loc/tr :pipeline-card-reactivate-action)
                                    :icon    "fal fa-redo-alt"
                                    :hidden? (fn [{:keys [entity]}]
                                               (not (some #{(:exit-opportunity/status entity)}
                                                          [:exit-opportunity.status/won
                                                           :exit-opportunity.status/on-hold
                                                           :exit-opportunity.status/lost])))
                                    :on-select!
                                    (fn [{:keys [entity]}]
                                      (exit-opportunity-actions/*->resurrect!
                                       {:exit-opportunity-id (:db/id entity)}
                                       identity
                                       (partial logging/error
                                                "Failed to set exit opportunity as active ")))}]))}]
               [scrollable-grid/view
                {:props-atom grid-atom
                 :hover-atom hover-atom}])]]])))))

(defn toolbar
  [args]
  (let [view-mode (or (:view-mode @db/view-settings)
                      (:view-mode (ls/get-in (events/ls-path)))
                      (:initial-mode args)
                      :board-mode)
        board-mode? (= view-mode :board-mode)
        card-mode (or (:card-mode @db/kanban)
                      :short-card)
        has-empty-groups? (when board-mode?
                            (kanban/has-empty-groups? @(r/track events/setup-args)))
        pipelines (->> @session/all-exit-oppo-pipelines
                       (filter session/has-entity-access?)
                       (remove :common/disabled?)
                       (remove :pipeline/inactive?))
        selected-pipeline-name (->> @session/selected-exit-oppo-pipeline
                                    (get @session/entities)
                                    (entity/display-string))]
    [:div.zap-toolbar.new-toolbar
     [:div.d-flex.justify-content-between.align-items-center.w-100
      [:div.toolbar-left
       [:div.d-flex.align-items-center
        (if (and (cu/multiple? pipelines)
                 @session/selected-exit-oppo-pipeline)
          [grid-components/pipeline-selector
           {:pipelines            pipelines
            :view-text            selected-pipeline-name
            :select-pipeline!     (fn [id]
                                    (session/set-module! :module/exit-process-management)
                                    (swap! session/selected-pipelines assoc
                                           :exit-opportunity-pipeline
                                           id)
                                    (routing/set-view! [:exit-opportunities-grid-with-pipeline :pipeline-id id]))
            :selected-pipeline-id @session/selected-exit-oppo-pipeline}]
          [:div
           {:class-name (fu/cs "toolbar-selected-pipeline")}
           [:label selected-pipeline-name]])
        [:span.grid-count
         (loc/tr :grid-entity-count [(count @db/sorted-kanban-entities)])]

        [grid-components/named-view-selector
         {:named-views               (events/named-views)
          :current-view              @db/view-settings
          :load-view!                (fn [id]
                                       (events/load-view! (events/named-view-by-id id))
                                       (grid/clear-selection! {:state db/exit-opportunities}))
          :delete-view!              named-view-events/start-delete-view!
          :accounts-with-view-access (session/active-accounts-with-pipeline-access
                                      @session/selected-exit-oppo-pipeline)
          :save-current-view!        events/save-current-view!}]

        (when board-mode?
          [grid-components/sort-selector
           {:view-settings   @db/view-settings
            :entity-type     :entity.type/exit-opportunity
            :sortable-fields (events/resolve-column-key-universe)
            :set-sort-by!    (fn [k dir]
                               (grid/set-sort-by (events/setup-args) k dir))}])

        (when board-mode?
          [grid-components/grouped-by-selector
           {:view-settings      @db/view-settings
            :entity-type        :entity.type/exit-opportunity
            :default-grouped-by :exit-opportunity/stage
            :grouped-by-fields  (->> (events/resolve-column-key-universe)
                                     (remove #{:exit-opportunity/status})
                                     (filter grid/groupable-attribute?))
            :set-grouped-by!    (fn [k]
                                  (swap! db/view-settings assoc :grouped-by k)
                                  (ls/update-in (events/ls-path)
                                                assoc
                                                :grouped-by
                                                k))}])]]

      [:div
       {:class "flex justify-content-end items-center gap-2"}
       ;(when-not board-mode?
       ;  [grid-components/editable-grid-toggle])
       (when (and board-mode? (not= card-mode :short-card))
         [button/square-secondary-open
          {:on-click (fn [_] (events/collapse-all!))
           :tooltip  (loc/tr :collapse-all)}
          [:i.fal.fa-compress-alt]])
       (when (and board-mode? (= card-mode :short-card))
         [button/square-secondary-open
          {:tooltip  (loc/tr :expand-all)
           :on-click (fn [_] (events/expand-all!))}
          [:i.fal.fa-expand-alt]])

       [button/square-secondary-open
        {:tooltip  (grid-components/view-mode-tooltip board-mode?)
         :on-click (fn [_]
                     (events/switch-mode! view-mode))}
        (if board-mode?
          [:i.fal.fa-table]
          [:i.fal.fa-signal-3.fa-rotate-180.kanban-icon])]

       (when (and board-mode? has-empty-groups?)
         [grid-utils/hide-empty-kanban-groups-toggle "exit-opportunities-grid-toolbar" db/kanban])

       [:div.toolbar-dropdown
        (zap-toolbar/dropdown (->> (toolbar-actions {:view-mode view-mode})
                                   (filter :dropdown-action?)
                                   (remove (fn [{:keys [hidden?]}]
                                             (when (fn? hidden?)
                                               (hidden?))))
                                   (sort-by :ord))
                              true)]]]]))

(defn view
  []
  (let [grid-store (atom {})
        close-atom (atom false)
        resizer (fn []
                  (js/setTimeout (partial vu/recompute-grid-sizes-with-state! grid-store) 100))]
    (.addEventListener js/window "resize" resizer)
    (r/create-class
     {:component-did-mount    (fn []
                                (fu/timeout 10 (partial events/setup close-atom)))
      :component-will-unmount (fn []
                                (reset! close-atom true)
                                (events/cleanup)
                                (.removeEventListener js/window "resize" resizer))
      :reagent-render         (partial render grid-store)})))

(defmethod routing/render-view :exit-opportunities-grid
  [{:keys [initial-mode route-params] :as args}]
  (session/sync-selected-pipeline-from-route!
   {:route-params            route-params
    :pipeline-key            :exit-opportunity-pipeline
    :all-pipelines-for-type  session/all-exit-oppo-pipelines})
  (if (session/new-grid-2023?)
    [pipeline-entity/render-page listing-exit-opportunity/config]
    (let [forbidden? (or (not (session/exit-process-management?))
                         (and (not (session/is-admin?))
                              (->> @session/all-exit-oppo-pipelines
                                   (filter session/has-entity-access?)
                                   (empty?))))
          no-pipeline-in-use? (and (session/exit-process-management?)
                                   (session/is-admin?)
                                   (->> @session/all-exit-oppo-pipelines
                                        (every? :pipeline/inactive?)))
          view-mode (or (:view-mode @db/view-settings)
                        (:view-mode (ls/get-in (events/ls-path)))
                        initial-mode
                        :board-mode)]
      (cond
        forbidden?
        [not-found/not-found-view]
        no-pipeline-in-use?
        [components/no-pipelines-in-use-view]
        :else
        [default-page-layout/view
         [:<>
          [components/card-settings-toolbar
           [toolbar args] db/kanban events/close-card-settings!]
          [view view-mode]]]))))
